// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.2 3.04C7 1.65 9 1.65 9.8 3.04L14.33 10.89C15.13 12.27 14.13 14 12.53 14H3.47C1.87 14 0.87 12.27 1.67 10.89L6.2 3.04Z',
  'M8.06 11.19H7.94V11.06H8.06V11.17M7.7 6.19L8.02 8.75L8.33 6.19L7.7 6.19Z',
];
